<script setup lang="ts">
import './assets/style.scss'
import type { PropType } from 'vue'
import { type StatusType, VIcons } from '@/shared/ui'
import { EventErrorType } from '@/entities/Object'

defineProps({
  statuses: {
    type: Array as PropType<StatusType[]>,
    default: () => [],
  },
  compact: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div class="v-status__list" :class="{ 'v-status__list_compact': compact }">
    <template v-if="statuses.length">
      <div
        v-for="item in statuses"
        class="v-status"
        :class="{
          'v-status_error': item.error && item.event_type == EventErrorType.ERROR,
          'v-status_warning': item.error && item.event_type == EventErrorType.WARNING,
          'v-status_badges': item.badge,
        }"
      >
        <VTooltip location="top">
          <span v-html="item.tooltip" />

          <template #activator="{ props }">
            <div v-if="item.text" class="v-status__text">
              {{ item.text }}
            </div>

            <div
              v-if="item.badge"
              class="v-status__badge"
              :class="{
                'v-status__badge_compact': String(item.badge).length < 3,
              }"
            >
              {{ item.badge }}
            </div>

            <VIcons v-bind="props" bold :type="item.icon" />
          </template>
        </VTooltip>
      </div>
    </template>
  </div>
</template>
